import styled from 'styled-components';

const Box = styled.div`
  box-sizing: border-box;
`;

export default Box;
